import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';

const Frontend = ({ listFrontend }) => {
    return (
        <div className="pochtabank-frontend">
            <FullWrapper caseName="pochtabank-frontendCase">
                <div className="pochtabank-frontendTitle">Скорость и&nbsp;современный фронтенд</div>
                <div className="pochtabank-frontendInner">
                    <div className="pochtabank-frontendLeft">
                        Быстродействие современного сайта чаще обусловлено скоростью загрузки
                        проекта в&nbsp;браузере, а&nbsp;не&nbsp;скоростью ответа бэкенда. Поэтому
                        в&nbsp;архитектуру сайта Почта Банк заложили Next.js. Этот фреймворк дает
                        максимальное покрытие кейсов производительности из&nbsp;коробки и&nbsp;все
                        ее&nbsp;релизы заточены на&nbsp;улучшение. Работающий на&nbsp;базе react
                        и&nbsp;TypeScript, Next.js делает разработку эффективной, гибкой
                        и&nbsp;легкой для дальнейшего развития.
                    </div>
                    <div className="pochtabank-frontendRight">
                        <div className="pochtabank-frontendRightText">
                            Новый технологический стек
                        </div>
                        <div className="pochtabank-frontendRightItems">
                            {listFrontend.map((item, index) => (
                                <div className="pochtabank-frontendRightItem" key={index}>
                                    <img
                                        src={item.icon}
                                        alt="icon"
                                        className="pochtabank-frontendRightIcon"
                                    />
                                    <div className="pochtabank-frontendRightName">{item.text}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Frontend;
